export interface Shortcut {
  name: string;
  desc?: string;
  keys: string[];
}

export interface ShortcutGroup {
  label: string;
  items: Shortcut[];
}

// Catálogo único consumido pelo ShortcutsSheet (?) e pelo card de Atalhos da
// página /settings. Único lugar a manter quando novo hotkey é adicionado.
// Tokens: 'mod' = ⌘/Ctrl, 'shift' = ⇧, 'enter' = ⏎, 'up'/'down' = ↑/↓, 'esc' = Esc.
export const SHORTCUT_GROUPS: ShortcutGroup[] = [
  {
    label: 'Geral',
    items: [
      { name: 'Command palette', desc: 'Buscar ações, canais e atalhos', keys: ['mod', 'k'] },
      { name: 'Mostrar atalhos', desc: 'Esta janela', keys: ['?'] },
      { name: 'Fechar overlay', desc: 'Diálogos, popovers, palette', keys: ['esc'] },
    ],
  },
  {
    label: 'Feed',
    items: [
      { name: 'Mensagem anterior / próxima', desc: 'Seleção dentro do feed', keys: ['up', 'down'] },
    ],
  },
  {
    label: 'Moderação (sobre msg selecionada)',
    items: [
      { name: 'Banir usuário', desc: 'Abre confirmação destrutiva', keys: ['b'] },
      { name: 'Timeout', desc: 'Aplica silêncio temporário', keys: ['t'] },
      { name: 'Deletar mensagem', keys: ['d'] },
    ],
  },
  {
    label: 'Broadcast',
    items: [
      { name: 'Focar composer', desc: 'Quando não estiver digitando', keys: ['/'] },
      { name: 'Enviar broadcast', keys: ['mod', 'enter'] },
      { name: 'Alternar destinos', desc: 'Cicla entre Twitch / YouTube / ambos', keys: ['mod', 'b'] },
    ],
  },
];

// `userAgentData.platform` é a API moderna (Client Hints); cai pra userAgent
// quando o browser ainda não expõe (Safari < 17, Firefox stable até 2026).
// `navigator.platform` é deprecated — não usar.
interface NavigatorUserAgentData {
  platform?: string;
}

export function isMacPlatform(): boolean {
  if (typeof navigator === 'undefined') return false;
  const uaData = (navigator as Navigator & { userAgentData?: NavigatorUserAgentData })
    .userAgentData;
  if (uaData?.platform) {
    return /mac/i.test(uaData.platform);
  }
  return /Mac|iPhone|iPad/.test(navigator.userAgent);
}

export function renderKeyToken(token: string, mac: boolean): string {
  if (token === 'mod') return mac ? '⌘' : 'Ctrl';
  if (token === 'shift') return mac ? '⇧' : 'Shift';
  if (token === 'enter') return '⏎';
  if (token === 'up') return '↑';
  if (token === 'down') return '↓';
  if (token === 'esc') return 'Esc';
  return token.toUpperCase();
}
